import React from 'react';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Home from './Pages/Home';
import Error404 from './Pages/Error';


const Routess = () => {
    return ( 
    
    <BrowserRouter>
    <Routes>
    <Route path='/' element={<Home />}/>
    <Route path='*' element={<Error404 />}/> 
    </Routes>
    </BrowserRouter>
        
     );
}
 
export default Routess;